import { Injectable } from '@angular/core';
import { AnalysisApiClientAccess } from '@nk/access-block';
import { AppFeatureKey, AppPagePrinter, AppPagePrinterPayload, AppRoleKey } from '@nk/data-entities-lib';
import { Observable } from 'rxjs';

@Injectable()
export class AppPagePrinterService {
  constructor(private _analysisApiAccess: AnalysisApiClientAccess) {}

  public postAppPagePrinter(
    payload: AppPagePrinterPayload,
    featureKeys: AppFeatureKey[] = [],
    roleKeys: AppRoleKey[] = [],
  ): Observable<AppPagePrinter> {
    return this._analysisApiAccess.post(
      `app-page-printer`,
      payload,
      null,
      [AppFeatureKey.base, ...featureKeys],
      roleKeys,
    );
  }
}
